import "./Projects.module.css";
import Header from "@/reusable_sections/Header";
import Projects from "./sections/Projects";
import GaleriaWykonanychPrac from "./sections/GaleriaWykonanychPrac";
import Faq from "./sections/Faq";
import Footer from "@/reusable_sections/Footer";
export default function ProjectsPage() {
  return <div>
      <Header />
      <Projects />
      <GaleriaWykonanychPrac />
      <Faq />
      <Footer />
    </div>;
}